import './bdc.scss';

//import { Download } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { AppBar, Button,   IconButton, Toolbar, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import jsPDF from 'jspdf';
import PropTypes from 'prop-types';
import React, {useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';

import logoDataDelegates from '../../../src/Assets/LOGOHTH.png';
import { extractCountryName } from '../../data/Countries';
//import {Table } from 'react-bootstrap';
// import  from '../../../src/Assets/LOGOHTH.png';
import { AdminDataDelegates, getFournisseurInfo } from '../../data/Interfaces';
import { useNumberFormatting } from '../../hooks/useNumberFormatting';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import { bdc, ordreMissionStyles } from '../../Styles/componentStyles';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { calculateTotal} from '../../Utils/utils';
import DialogInterompreMission from '../Dialogs/DialogInterompreMission';
import { buttonStyles, buttonStylesRed } from '../docsAdministrative/JsObjectStyles';
import { Transition } from '../shared/ReusableSmallComponents';

const BDC = ({ mission, handleClose, open,role }) => {

    BDC.propTypes = {
        children: PropTypes.any,
        mission: PropTypes.any,
        open: PropTypes.any,
        handleClose: PropTypes.func,
        role: PropTypes.any,
    };
    // console.log('misssssssssssion',mission);
    const { addEuro4Decimal } = useNumberFormatting();

    const [openNestedInterruption,setOpenNestedInterruption]=useState(false);
    const descriptionElementRef = React.useRef(null);
    const scroll='paper';

    const [adresseFacturation, setAdresseFacturation] = useState({});
    const [donneeMission, setDonneeMission] = useState({});
    const [delaiPaiement,setDelaiPaiement] = useState('');
    const [disabledInterruption,setDisabledInterruption]=useState(false);
    //const [fournisseur,setFournisseur]=useState({});
    const roleUser=useRole();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    useEffect(() => {
        var temp={};
        var temp2={};
        //var fourniss={};
        console.log('misionnn',mission);
        if(mission){
            if(role=='client'){
                let clientOrEsn=mission?.companyDataId ?? mission?.esnId;
                temp.nomEntreprise = clientOrEsn?.profileEntreprise?.nom;
                if(clientOrEsn?.donneeFacturation?.adresseFacturation)
                    temp.adresse=clientOrEsn?.donneeFacturation?.adresseFacturation +', '+ extractCountryName(clientOrEsn?.donneeFacturation?.localisation) +', '+clientOrEsn?.donneeFacturation?.codePostal ;
                else
                    temp.adresse=clientOrEsn?.profileEntreprise?.address +', '+  extractCountryName(clientOrEsn?.profileEntreprise?.localisation) +', '+ clientOrEsn?.profileEntreprise?.codePostal;
                temp.email=clientOrEsn?.donneeFacturation?.emailFacturation;
                temp.siret=clientOrEsn?.profileEntreprise?.siret;
                temp.tele=clientOrEsn?.donneeFacturation?.teleFacturation;
                temp.noTva=clientOrEsn?.profileEntreprise?.noTVA;
                setAdresseFacturation(temp);
                setDelaiPaiement(clientOrEsn?.donneeFacturation?.delaiPaiement);
                temp2.description = mission?.titre;
                temp2.refMission= mission?.missionId;
                temp2.quantite= mission?.BDCs?.nbJoursBDC;
                temp2.prixUnitaire= mission?.BDCs?.tjClient;
                temp2.total=calculateTotal(mission?.BDCs?.nbJoursBDC,mission?.BDCs?.tjClient);
                setDonneeMission(temp2);
                console.log('wasAcepted',mission?.interruptionBackOffice?.wasAccepted );
                console.log('client', mission?.interruptionClient?.isInterrupted );
                setDisabledInterruption((mission?.interruptionBackOffice?.wasAccepted || mission?.interruptionClient?.isInterrupted ));
            }
            if(role=='expert'){
                let esnOrExpertEntreprise = mission?.esnExpertOwnerId?.profileEntreprise ?? mission?.expertId?.entreprise;
                temp.nomEntreprise = esnOrExpertEntreprise?.nom ?? esnOrExpertEntreprise?.nom;
                temp.adresse = esnOrExpertEntreprise?.address+', '+esnOrExpertEntreprise?.localisation;
                temp.email = mission?.esnExpertOwnerId?.persoData?.email ?? mission?.expertId?.persoData?.email;
                temp.siret = esnOrExpertEntreprise?.noImmatriculation ?? esnOrExpertEntreprise?.siret;
                temp.tele = mission?.expertId?.persoData?.tele ?? mission?.esnExpertOwnerId?.persoData?.tele;
                temp.noTva = esnOrExpertEntreprise?.noTVA;
                setAdresseFacturation(temp);
                setDelaiPaiement(mission?.companyDataId?.donneeFacturation?.delaiPaiement ?? mission?.esnExpertOwnerId?.donneeFacturation?.delaiPaiement ?? mission?.esnId?.donneeFacturation?.delaiPaiement);
                temp2.description = mission?.titre;
                temp2.refMission = mission?.missionId;
                temp2.quantite = mission?.BDCs?.nbJoursBDC;
                temp2.prixUnitaire = mission?.BDCs?.tj;
                temp2.total = calculateTotal(mission?.BDCs?.nbJoursBDC,mission?.BDCs?.tj);
                setDonneeMission(temp2);
                console.log('wasAcepted',mission?.interruptionBackOffice?.wasAccepted );
                console.log('expert', mission?.interruptionExpert?.isInterrupted );
                setDisabledInterruption((mission?.interruptionBackOffice?.wasAccepted || mission?.interruptionExpert?.isInterrupted));
                //temp2.tvaAppliquee= mission?.tvaExpert;
                //temp2.totalTva= mission?.totalHTExpert*mission?.tvaExpert/100;

            }
        }
    }, [mission,role]);

    // ? we focus on what here
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const handleGeneratePdf = () => {
        const doc = new jsPDF({
            format: 'a2',
            //orientation,
            unit: 'px',
        });
        //var pageCount = doc.internal.getNumberOfPages();
        //doc.html(document.getElementById('reportTemplateRef')).then(() => doc.save('document.pdf'));
        doc.html(document.getElementById('reportTemplateRef'),
            {
                async callback(doc) {
                    // console.log('wiiiidth',doc.internal.getNumberOfPages());
                    //doc.deletePage(pageCount)
                    await doc.save(role=='expert' ? mission?.BDCs?.bdcId+ 'E' : mission?.BDCs?.bdcId);
                },
                margin:[20,48,20,48],
                autoPaging:'text',
            },
        );
    };

    return (
        <Dialog
            fullScreen
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',justifyContent:'space-around',background: '#F5F6FA',paddingTop: '90px',paddingLeft: '24px',paddingRight:device=='desktop'?'0px':'24px',paddingBottom: '24px',gap:device=='desktop'?'0px':'16px',}}>
                {device!='desktop' &&
                    <div style={{display:'flex',flexDirection:'column',gap:'30px'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                            <h5 className='TitleFrame1OM'>
                                {i18n.t('Bon de commande')}
                            </h5>
                            <IconButton
                                //className='TelechargerMissionOM'
                                //onClick={printOrdreMission}
                                onClick={handleGeneratePdf}
                                //variant="outlined"
                                style={{...buttonStyles(),...{color:'#214DCE',border: '1px solid #214DCE',order:2,margin:'0'}}}
                                //startIcon={<FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0'}} />}
                                //onClick={handleExportWithComponent}
                            >
                                <FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0px'}} />
                            </IconButton>
                        </div>
                        <div style={{borderBottom:'solid 2px #C3C9F1',margin:'0px'}}></div>
                    </div>
                }
                <div className='frame1bdc'>
                    <div
                        id='reportTemplateRef'
                        style={ordreMissionStyles.page}
                    >
                        {mission &&
                            <>
                                <div style={bdc.FileFrame0Bdc}>
                                    <div
                                        style={ordreMissionStyles.logo}
                                    >
                                        <img src={logoDataDelegates}/>
                                        {/*<Logo />*/}
                                    </div>
                                    <div style={bdc.FileFrame1Bdc}>
                                        <h4 style={bdc.FileFrame2Bdc}>{i18n.t('Bon de commande')}</h4>
                                        <div style={bdc.FileFrame3Bdc}>
                                            <p style={bdc.FileFrame4Bdc}>
                                                {i18n.t('Réf')}: {role=='expert' ? mission?.BDCs?.bdcId+ 'E' : mission?.BDCs?.bdcId}
                                            </p>
                                            <p style={bdc.FileFrame5Bdc}>
                                                {i18n.t('Date d\'émision')}: {formatDateJJMMYYYY(mission?.BDCs?.createdAt)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div style={bdc.FileFrame6Bdc}>
                                    <div style={bdc.FileFrame7Bdc}>
                                        <h4 style={bdc.FileFrame8Bdc}>
                                            {i18n.t('Fournisseur')}
                                        </h4>
                                        <div style={bdc.FileFrame9Bdc}>
                                            <p style={bdc.FileFrame18Bdc}>{role=='client' ? getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).societe : adresseFacturation?.nomEntreprise}</p>
                                            <p style={bdc.FileFrame11Bdc}>{role=='client' ? getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).adresse : adresseFacturation?.adresse }</p>
                                            <div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{i18n.t('E-mail')}:</p><p  style={bdc.FileFrame11Bdc}> &nbsp;&nbsp;{role=='client' ? AdminDataDelegates.email : adresseFacturation?.email}</p>
                                            </div>
                                            <div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{i18n.t('Téléphone')}:</p><p  style={bdc.FileFrame11Bdc}> &nbsp;&nbsp;{role=='client' ?AdminDataDelegates.tele:adresseFacturation?.tele}</p>
                                            </div>
                                            <div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{i18n.t('Siret')}: </p><p  style={bdc.FileFrame11Bdc}> &nbsp;&nbsp;{role=='client' ?getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).siret:adresseFacturation?.siret}</p>
                                            </div>
                                            <div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{i18n.t('N° du TVA')}:</p><p  style={bdc.FileFrame11Bdc}> &nbsp;&nbsp;{role=='client' ?getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).notva:adresseFacturation?.noTva}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={bdc.FileFrame12Bdc}>
                                        <h4 style={bdc.FileFrame8Bdc}>
                                            {i18n.t('Adresse de facturation')}
                                        </h4>
                                        <div style={bdc.FileFrame9Bdc}>
                                            <p style={bdc.FileFrame18Bdc}>{role=='client' ? adresseFacturation?.nomEntreprise : getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).societe }</p>
                                            <p style={bdc.FileFrame11Bdc}>{role=='client' ? adresseFacturation?.adresse : getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).adresse}</p>
                                            {/*On les masques pour #v0*/}
                                            {/*<div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>E-mail:</p><p style={bdc.FileFrame11Bdc}>&nbsp;&nbsp;{role=='client' ? adresseFacturation?.email : AdminDataDelegates.email}</p>
                                            </div>
                                            <div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>Téléphone:</p><p  style={bdc.FileFrame11Bdc}>&nbsp;&nbsp;{role=='client' ? adresseFacturation?.tele : AdminDataDelegates.tele}</p>
                                            </div>*/}
                                            <div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{i18n.t('Siret')}: </p><p  style={bdc.FileFrame11Bdc}>&nbsp;&nbsp;{role=='client' ? adresseFacturation?.siret : getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).siret}</p>
                                            </div>
                                            <div style={bdc.FileFrame10Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{i18n.t('N° du TVA')}:</p><p  style={bdc.FileFrame11Bdc}>&nbsp;&nbsp;{role=='client' ? adresseFacturation?.noTva :getFournisseurInfo(mission?.BDCs?.backOfficeId?.persoData?.email).notva}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={bdc.FileFrame13Bdc}>
                                    <h4 style={bdc.FileFrame8Bdc}>
                                        {i18n.t('Mission')}
                                    </h4>
                                    <div style={bdc.FileFrame9Bdc}>
                                        <table style={{border: '1px solid',width:'780px'}}>
                                            <tr style={{border: '1px solid',height:'40px',background: '#d5dce5'}}>
                                                <th style={{border: '1px solid',width:'400px',padding:'10px'}}>{i18n.t('Description')}</th>
                                                <th style={{border: '1px solid',textAlign:'center'}}>{i18n.t('Quantité(jour)')}</th>
                                                <th style={{border: '1px solid',textAlign:'center'}}>{i18n.t('Prix unitaire (HT)')}</th>
                                            </tr>
                                            <tr style={{border:'1px'}}>
                                                <td style={{border: '1px solid',padding:'10px'}}><b>{donneeMission?.description}</b><br/>{i18n.t('Réf mission')} :{donneeMission?.refMission}</td>
                                                <td style={{border: '1px solid',textAlign:'center'}}>{donneeMission?.quantite}</td>
                                                <td style={{border: '1px solid',textAlign:'center'}}>
                                                    {addEuro4Decimal(donneeMission?.prixUnitaire, 'EUR')}</td>
                                            </tr>
                                        </table>
                                        {/*<Table
                                            striped
                                            bordered
                                            hover
                                            responsive
                                            style={{borderColor:'black',width:'790px'}}
                                        >
                                            <thead style={{borderColor:'black'}}>
                                                <tr style={{borderColor:'black'}}>
                                                    <th style={{borderColor:'black'}}>Description</th>
                                                    <th style={{borderColor:'black'}}>Quantité</th>
                                                    <th style={{borderColor:'black'}}>Prix unitaire</th>
                                                    {/* <th>Total expérience</th>
                                                <th>Expérience la plus récente</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{borderColor:'black'}}>
                                                <td style={{borderColor:'black'}}>Développeur Full STACK Java Réf mission : ASS-50001</td>
                                                <td style={{borderColor:'black'}}>82</td>
                                                <td style={{borderColor:'black'}}>650 EUR</td>
                                            </tbody>
                                        </Table>*/}
                                    </div>
                                    <div style={bdc.FileFrame9Bdc}>
                                        <h6 style={{display:'flex',flexDirection:'row',gap:'20',width:'250px',alignSelf:'stre'}} >
                                            <span style={{display:'flex',width:'50%'}}>{i18n.t('Date de début')} :</span>
                                            {formatDateJJMMYYYY(mission?.dateDebBdc)}
                                        </h6>
                                        <h6 style={{display:'flex',flexDirection:'row',gap:'20',width:'250px',alignSelf:'stre'}} >
                                            <span style={{display:'flex',width:'50%'}}>{i18n.t('Date de Fin')} :</span>
                                            {formatDateJJMMYYYY(mission?.dateFinBdc)}</h6>
                                    </div>
                                    <div style={bdc.FileFrame14Bdc}>
                                        <table style={{border: '1px solid',width:'300px'}}>
                                            <tr style={{border: '1px solid',height:'33px'}}>
                                                <th style={{border: '1px solid',width:'100px',paddingLeft:'10px'}}>{i18n.t('Total (HT)')}</th>
                                                <th style={{border: '1px solid',paddingLeft:'10px'}}>{addEuro4Decimal(donneeMission?.total, 'EUR')}</th>
                                            </tr>
                                        </table>
                                    </div>
                                    {/*<div style={{width:'300px',justifyContent:'flex-end',border:'1px solid black'}}>
                                        <h6 style={{borderRight:'1px solid black'}}>Total</h6>
                                        <h5></h5>
                                    </div>*/}
                                </div>
                                <div style={bdc.FileFrame15Bdc}>
                                    <h6><b>{i18n.t('Conditions de paiement')}:</b></h6>
                                    {/*<span style={{fontSize: '18px'}}>{delaiPaiement}</span> */}
                                    {/* <p style={bdc.FileFrame11Bdc}>
                                        Paiement par virement, dès réception du règlement client.<br/>
                                        (Rappel conditions de paiement client :{delaiPaiement} jours à réception de facture. Conformément à l&apos;article L441-6 du code de commerce,
                                        en cas de retard de paiement, une indemnité de trois fois le taux de l&apos;intérêt légal en vigueur ainsi qu&apos;une indemnité
                                        forfaitaire pour frais de recouvrement de 40€, seront exigibles).
                                    </p> */}
                                    <p style={bdc.FileFrame11Bdc}>
                                        {i18n.t('Paiement par virement, ')}{delaiPaiement} {i18n.t('jours à réception de facture.')}<br/>
                                        {i18n.t('Conformément à l\'article L441-6 du code de commerce, en cas de retard de paiement, une indemnité de trois fois le taux de l\'intérêt légal en vigueur ainsi qu\'une indemnité forfaitaire pour frais de recouvrement de 40€, seront exigibles.')}
                                    </p>

                                </div>
                                {/*<div style={bdc.FileFrame16Bdc}>
                                    <h4 style={bdc.FileFrame8Bdc}>
                                        Adresse de livraison
                                    </h4>
                                    <div style={bdc.FileFrame9Bdc}>
                                        A ajouter l&apos;adresse du client
                                    </div>
                                </div>*/}
                            </>
                        }
                    </div>
                </div>

                <div
                    className='frame0bdc'
                    style={{justifyContent:'space-between',padding:'0px'}}
                >
                    <div style={{display:'flex',justifyContent:'flex-end',width:device=='desktop' ?'auto':'100%'}}>
                        <Button
                            className='TelechargerMissionOM'
                            variant="text"
                            style={{...buttonStyles(),...{color:'#272D3C',background:device=='desktop'?'none':'#E7EAF9',width:device=='desktop'?'auto':'100%'}}}
                            startIcon={<FileDownloadOutlinedIcon style={{color:'#272D3C'}} />}
                            onClick={handleGeneratePdf}
                        >
                            {i18n.t('Télécharger le BDC')} {disabledInterruption}
                        </Button>
                    </div>
                    {(roleUser == 'expert' || roleUser == 'client'|| roleUser == 'esn') &&
                        <div style={{display:'flex',justifyContent:'flex-start',width:device=='desktop' ?'auto':'100%'}}>
                            <Tooltip title={disabledInterruption==true ? 'la demande d\'interruption a été déjà faite ' : ' '}>
                                <span style={{width:device=='desktop' ?'auto':'100%'}}>
                                    <Button
                                        variant='contained'
                                        style={{...buttonStylesRed((disabledInterruption || mission?.statutMission=='terminee'|| mission?.statutMission=='annulee')),...{width:device=='desktop'?'auto':'100%'}}}
                                        disabled={(disabledInterruption || mission?.statutMission=='terminee'|| mission?.statutMission=='annulee')}
                                        onClick={() => setOpenNestedInterruption(true) }
                                    >
                                        {i18n.t('Interrompre la mission')}
                                    </Button>
                                </span>
                            </Tooltip>
                        </div>
                    }
                </div>
            </div>
            <DialogInterompreMission
                handleCloseNestedInterruption={() => {
                    setOpenNestedInterruption(false);
                    handleClose();
                }}
                openNestedInttreption={openNestedInterruption}
                mission={mission}
            />
        </Dialog>
    );
};

export default BDC;
